module.exports = __webpack_public_path__ + "media/images/background-4812171ce6a7553e5c7d005da79866f8.svg";